import styled from 'styled-components';
import { Text03 } from '../../styles';

export const placeholderForEmpty = '\u2014';
const EmptyContent = styled.span`
  ${Text03};
`;

export const NoValue = () => <EmptyContent>{placeholderForEmpty}</EmptyContent>;
